import React, {useEffect, useState} from "react";
import {Editor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styled from 'styled-components';
import {convertToRaw, EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {Button, Col, Input, Row, Space, message, Form, Select, Card, Mentions, Tabs, Table, Checkbox } from "antd";
import axios from "axios";
import {httpStatus} from "../../../../lib/createRequestSaga";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {errorHandle} from "../../../../lib/BuilderUtils";
import DefaultLoading from "../../DefaultLoading";
import {DefaultCard} from "../../../../pages/PageStyleBox";
import queryString from "query-string";
import {isEmpty} from "../../../../lib/StringUtils";
import {useTranslation} from "react-i18next";

const { TextArea } = Input;

const EditorWrapper = styled.div`
    .wrapper-class{
        //width: 50%;
        margin: 0 auto;
        margin-bottom: 1rem;
    }
    .editor {
        height: 350px !important;
        border: 1px solid #f1f1f1 !important;
        padding: 5px !important;
        border-radius: 2px !important;
    }
  
  .rdw-suggestion-dropdown {
    min-width: 200px !important;
  }
  
  .rdw-suggestion-option-active{
    user-focus: '';
  }
`;

const IntroduceContent = styled.div`
  position: relative;
  //border: 0.0625rem solid #d7e2eb;
  //border-radius: 0.75rem;
  overflow: hidden;
  padding: 1.5rem;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 4rem;
`;

// 템플릿 유형과 관계없이 항상 사용 가능한 기본 멘션
const BASE_MENTIONS = ['{protocolName}', '{studyName}', '{subjectId}', '{siteCode}', '{siteName}'];
// SAE Report 보고용 템플릿에서만 사용 가능한 멘션 (메일 제목/내용 모두 사용 가능)
const REPORT_MENTIONS = ['{AETerm}', '{AEStartDate}', '{AEEndDate}', '{ReportType}'];
// 검증 대상이 되는 전체 멘션 목록
const ALL_MENTIONS = [...BASE_MENTIONS, ...REPORT_MENTIONS, '{SAEList}'];

// Preview에서 표로 치환할 SAEList 멘션 (에디터가 만든 멘션 링크 전체 또는 텍스트)
const SAE_LIST_MENTION_REGEX = /<a[^>]*>\s*\$\{SAEList\}\s*<\/a>|\$\{SAEList\}/g;
const SAE_LIST_TABLE_CELL_STYLE = 'border: 1px solid #d9d9d9; padding: 4px 12px; text-align: center;';

const EmailNotice = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [form] = Form.useForm();
    const query = queryString.parse(location.search);

    // useState로 상태관리하기 초기값은 EditorState.createEmpty()
    // EditorState의 비어있는 ContentState 기본 구성으로 새 개체를 반환 => 이렇게 안하면 상태 값을 나중에 변경할 수 없음.
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editorToHtml, setEditorToHtml] = useState(null);
    const [suggestionList, setSuggestionList] = useState(null);

    const [emailNoticeTemplate, setEmailNoticeTemplate] = useState(null);
    const [studySiteList, setStudySiteList] = useState([]);
    const [filterSiteList, setFilterSiteList] = useState([]);
    const [studyRoleList, setStudyRoleList] = useState([]);
    const [receiveRoleVOList, setReceiveRoleVOList] = useState([]);

    const [selectType, setSelectType] = useState([]);
    const [selectEnv, setSelectEnv] = useState([]);
    const [selectSite, setSelectSite] = useState([]);
    const [selectRoles, setSelectRoles] = useState([]);

    // SAE 관련 템플릿 유형 (NONE: 사용 안 함 / REPORT: 보고용 / NOTIFY: 발생,수정 알림용)
    const [saeTemplateType, setSaeTemplateType] = useState('NONE');

    const [isLoading, setLoading] = useState(false);
    const {t} = useTranslation();

    const envData = [
        {
            key: '1',
            name: 'DEV',
        },
        {
            key: '2',
            name: 'UAT',
        },
        {
            key: '3',
            name: 'PROD',
        },
    ];

    // 사용 위치(title: 메일 제목 / content: 메일 내용)와 템플릿 유형에 따라 사용 가능한 멘션 목록 반환
    const getMentionList = (target) => {
        return (suggestionList ?? []).filter((suggestion) => {
            if(BASE_MENTIONS.includes(suggestion.value)) {
                return true;
            }
            if(saeTemplateType === 'REPORT') {
                return REPORT_MENTIONS.includes(suggestion.value);
            }
            if(saeTemplateType === 'NOTIFY') {
                // AETerm은 메일 제목에서만, SAEList는 메일 내용에서만 사용 가능
                return (suggestion.value === '{AETerm}' && target === 'title')
                    || (suggestion.value === '{SAEList}' && target === 'content');
            }
            return false;
        });
    };

    // Preview 렌더링 시 SAEList 멘션을 SAE 목록 표 형태로 치환
    const renderPreviewHtml = (html) => {
        if(isEmpty(html) || !html.includes('${SAEList}')) {
            return html;
        }

        // 넘버링 표시용 예시 행 3개
        const saeListRows = [1, 2, 3].map((no) =>
            '<tr>' +
                '<td style="' + SAE_LIST_TABLE_CELL_STYLE + '">' + no + '</td>' +
                '<td style="' + SAE_LIST_TABLE_CELL_STYLE + '">${AETerm}</td>' +
                '<td style="' + SAE_LIST_TABLE_CELL_STYLE + '">${AEStartDate}</td>' +
                '<td style="' + SAE_LIST_TABLE_CELL_STYLE + '">${AEEndDate}</td>' +
            '</tr>'
        ).join('');

        const saeListTable =
            '<table style="border-collapse: collapse; margin: 4px 0;">' +
                '<thead><tr>' +
                    '<th style="' + SAE_LIST_TABLE_CELL_STYLE + ' background-color: #fafafa;">No</th>' +
                    '<th style="' + SAE_LIST_TABLE_CELL_STYLE + ' background-color: #fafafa;">' + t('studies.template.sae.list.column.ae.term') + '</th>' +
                    '<th style="' + SAE_LIST_TABLE_CELL_STYLE + ' background-color: #fafafa;">' + t('studies.template.sae.list.column.start.date') + '</th>' +
                    '<th style="' + SAE_LIST_TABLE_CELL_STYLE + ' background-color: #fafafa;">' + t('studies.template.sae.list.column.end.date') + '</th>' +
                '</tr></thead>' +
                '<tbody>' + saeListRows + '</tbody>' +
            '</table>';

        return html.replace(SAE_LIST_MENTION_REGEX, saeListTable);
    };

    // 텍스트에 포함된 멘션 중 현재 템플릿 유형/사용 위치에서 허용되지 않는 멘션 목록 반환
    const findInvalidMentions = (text, target) => {
        const allowedValues = getMentionList(target).map((suggestion) => suggestion.value);
        return ALL_MENTIONS.filter((mention) => !allowedValues.includes(mention) && (text ?? '').includes(mention));
    };

    const onEditorStateChange = (editorState) => {
        // editorState에 값 설정
        // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())));
        const htmlText = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        setEditorToHtml(htmlText);
        setEditorState(editorState);

        // console.log('htmlText =>', htmlText);
        form.setFieldsValue({content:htmlText});

    };

    useEffect( () => {
        (async () => {
            try {
                const {status, data} = await axios.get(`/api/builder/studies/${params.sid}/email-notice/edit`, {params: query});

                if (status === httpStatus.ok) {
                    setSuggestionList(data?.suggestionList);
                    setStudySiteList(data?.studySites);

                    const tmpStudyRoleList = [];
                    if(data?.studyRoles) {
                        data.studyRoles.filter((role) => {
                            const tmp = {
                                id : role.id,
                                name: role.shortName,
                            }
                            tmpStudyRoleList.push(tmp);
                        });
                    }
                    setStudyRoleList(tmpStudyRoleList);

                    form.setFieldsValue(data?.emailNoticeTemplate);
                    setEmailNoticeTemplate(data?.emailNoticeTemplate);
                    setSaeTemplateType(data?.emailNoticeTemplate?.reportSAE ? 'REPORT'
                                        : data?.emailNoticeTemplate?.notifySAE ? 'NOTIFY' : 'NONE');
                    setReceiveRoleVOList(data?.emailNoticeTemplate?.receiveRoleVOList);

                    setEditorToHtml(data?.emailNoticeTemplate.content||"");
                    const blocksFromHtml = htmlToDraft(data?.emailNoticeTemplate.content||"");
                    if (blocksFromHtml) {
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorState = EditorState.createWithContent(contentState);
                        setEditorState(editorState);
                    }
                }
            } catch (e) {
                errorHandle(e, navigate);
            }
        })();

    }, []);

    const onFinish = async (values) => {
        // 템플릿 유형에 따라 허용되지 않은 멘션이 있는 지 검증
        const invalidTitleMentions = findInvalidMentions(values.title, 'title');
        const invalidContentMentions = findInvalidMentions(values.content, 'content');
        if(invalidTitleMentions.length > 0 || invalidContentMentions.length > 0) {
            if(invalidTitleMentions.length > 0) {
                message.error(t('studies.template.mention.not.allowed.title', {mentions: invalidTitleMentions.join(', ')}));
            }
            if(invalidContentMentions.length > 0) {
                message.error(t('studies.template.mention.not.allowed.content', {mentions: invalidContentMentions.join(', ')}));
            }
            return;
        }

        //저장 중 로딩 설정
        setLoading(true);

        console.log('Received values of form:', values);
        const body = {
            ...emailNoticeTemplate,
            ...values
        }
        body.reportSAE = saeTemplateType === 'REPORT';
        body.notifySAE = saeTemplateType === 'NOTIFY';
        body.emailNoticeReceiveRoleList.splice(0); // role list 초기화

        try {
            const {status, data} = await axios({
                url: `/api/builder/studies/${params.sid}/email-notice/edit`,
                data: body,
                method: 'post'
            });

            if(status === httpStatus.ok) {
                message.success(data?.message);
                navigate(`/studies/${params.sid}/email-notice`);
            }
        } catch(e) {
            errorHandle(e);
        }

        setLoading(false);
    };

    const onEnvChange = (value) => {
        setSelectEnv(value);

        setFilterSiteList([
            {id: -1, name: "All"}, //ALL DATA
            ...studySiteList.filter((site) => {return site.envs.some((env) => env.key === value[0])})
        ]);
        setSelectSite([]);
    }

    const onSiteChange = (value) => {
        setSelectSite(value);
        setSelectRoles([]);
    }

    const onSelectRoles = (values) => {
        setSelectRoles(values);
    }

    const add = () => {
        let tmpReceiveRoleList = [...receiveRoleVOList];
        let newReceiveRoleList = [];

        if(selectRoles) {
            selectRoles.map((roleId) => {
                const tmp = {
                    // receiveType: selectType[0],
                    key: selectEnv[0]+'_'+selectSite[0]+'_'+roleId,
                    env: selectEnv[0],
                    studySiteId: selectSite[0],
                    studyRoleId: roleId,
                    studySiteName: filterSiteList.find(s => s.id === selectSite[0]).name,
                    studyRoleName: studyRoleList.find(r => r.id === roleId).name,
                }

                tmpReceiveRoleList.push(tmp);
            })

            newReceiveRoleList = tmpReceiveRoleList.reduce((prev, now) => {
                if(!prev.some(obj => obj.env === now.env && obj.studySiteId === now.studySiteId && obj.studyRoleId === now.studyRoleId)) {
                    prev.push(now);
                }
                return prev;
            }, []);
        }
        // console.log(newReceiveRoleList);
        setReceiveRoleVOList(newReceiveRoleList);
        form.setFieldsValue({receiveRoleVOList: newReceiveRoleList});
    }

    const handleDelete = (receiveRole) => {
        // console.log(receiveRole);
        const newData = receiveRoleVOList.filter((item) => item.key !== receiveRole.key);
        setReceiveRoleVOList(newData);
        form.setFieldsValue({receiveRoleVOList: newData});
    };

    return (
        <>
            {
                (suggestionList === null && editorToHtml === null) ? (
                    <DefaultLoading />
                ) : (
                    <DefaultCard>
                        <Row style={{margin:'1rem'}}>
                            <Col span={12}>
                                <Space direction="vertical">
                                    <Form name="dynamic_form_nest_item"
                                          form={form}
                                          onFinish={onFinish} autoComplete="off"
                                    >
                                        <Card title={<h5>e-Mail Template</h5>}>
                                            <h6 style={{fontWeight: 700, marginBottom: '0.5rem', paddingLeft: '0.5rem'}}>
                                                {t('studies.template.sae.group.title')}
                                            </h6>
                                            <div style={{display: 'flex',
                                                         border: '1px solid #d9d9d9', borderRadius: '6px',
                                                         padding: '0.75rem 1rem', marginBottom: '0.5rem'}}>
                                                <Checkbox checked={saeTemplateType === 'REPORT'}
                                                          style={{marginLeft: '2%', width: '48%'}}
                                                          onChange={(e) => setSaeTemplateType(e.target.checked ? 'REPORT' : 'NONE')}>
                                                    {t('studies.template.sae.report')}
                                                </Checkbox>
                                                <Checkbox checked={saeTemplateType === 'NOTIFY'}
                                                          onChange={(e) => setSaeTemplateType(e.target.checked ? 'NOTIFY' : 'NONE')}>
                                                    {t('studies.template.sae.notify')}
                                                </Checkbox>
                                            </div>
                                            <ul style={{color: '#8c8c8c', fontSize: '0.8rem',
                                                        paddingLeft: '1.25rem', marginBottom: '1.5rem'}}>
                                                <li>{t('studies.template.sae.report.desc')}</li>
                                                <li>{t('studies.template.sae.notify.desc')}</li>
                                            </ul>
                                            <h6 style={{fontWeight: 700, marginBottom: '0.5rem', paddingLeft: '0.5rem'}}>
                                                {t('studies.template.name.group.title')}
                                            </h6>
                                            <Form.Item
                                                name={'title'}
                                                rules={[{required: true, message: 'Missing title'},{ max: 255, message: 'Please enter Titles in 255 characters or less.' }]}
                                            >
                                                <Mentions
                                                    prefix={'$'}
                                                    placeholder="Title"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                >
                                                    {
                                                        getMentionList('title').map((suggestion, index) => (
                                                            <Mentions.Option key={index} value={`${suggestion?.value}`}>
                                                                {suggestion?.text}
                                                            </Mentions.Option>
                                                        ))
                                                    }
                                                </Mentions>
                                            </Form.Item>
                                            <Form.Item
                                                name={'content'}
                                                fieldKey={'content'}
                                                rules={[{required: true, message: 'Missing content'}]}
                                                hidden={true}
                                            >
                                                <TextArea/>
                                            </Form.Item>
                                            <h6 style={{fontWeight: 700, marginBottom: '0.5rem', paddingLeft: '0.5rem'}}>
                                                {t('studies.template.mail.group.title')}
                                            </h6>
                                            <EditorWrapper>
                                                <Editor
                                                    // 템플릿 유형 변경 시 mention suggestion 목록이 갱신되도록 재마운트
                                                    key={saeTemplateType}
                                                    // 에디터와 툴바 모두에 적용되는 클래스
                                                    wrapperClassName="wrapper-class"
                                                    // 에디터 주변에 적용된 클래스
                                                    editorClassName="editor"
                                                    // 툴바 주위에 적용된 클래스
                                                    toolbarClassName="toolbar-class"
                                                    // 툴바 설정
                                                    toolbar={{
                                                        // inDropdown: 해당 항목과 관련된 항목을 드롭다운으로 나타낼것인지
                                                        list: {inDropdown: true},
                                                        textAlign: {inDropdown: true},
                                                        link: {inDropdown: true},
                                                        history: {inDropdown: false},
                                                    }}
                                                    placeholder={t('studies.pls.write.content')}
                                                    // 한국어 설정
                                                    // localization={{
                                                    //     locale: 'ko',
                                                    // }}
                                                    // 초기값 설정
                                                    editorState={editorState}
                                                    // 에디터의 값이 변경될 때마다 onEditorStateChange 호출
                                                    onEditorStateChange={onEditorStateChange}
                                                    mention={{
                                                        separator: ' ',
                                                        trigger: '$',
                                                        suggestions: getMentionList('content'),
                                                    }}
                                                />
                                            </EditorWrapper>
                                            <Row>
                                                <Col span={24}>
                                                    <Card title={<h5>{t('studies.email.reception.setting')}</h5>}>
                                                        <Tabs defaultActiveKey={'receiver'} tabPosition={'left'} type={'card'}>
                                                            <Tabs.TabPane tab={'Role'} key={'role'}>
                                                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                    <Table
                                                                        style={{marginRight: "10px", width: "50%"}}
                                                                        bordered={true}
                                                                        size={"small"}
                                                                        pagination={false}
                                                                        rowKey="name"
                                                                        dataSource={envData}
                                                                        columns={[
                                                                            {
                                                                                title: 'Env',
                                                                                dataIndex: 'name',
                                                                            }
                                                                        ]}
                                                                        rowSelection={
                                                                            {
                                                                                type: 'radio',
                                                                                columnWidth: 20,
                                                                                onChange: onEnvChange,
                                                                            }
                                                                        }
                                                                    />
                                                                    <Table
                                                                        style={{marginRight: "10px", width: "-webkit-fill-available"}}
                                                                        bordered={true}
                                                                        size={"small"}
                                                                        pagination={{
                                                                            pageSize: 5,
                                                                            defaultPageSize: 5,
                                                                        }}
                                                                        rowKey="id"
                                                                        dataSource={filterSiteList}
                                                                        columns={[
                                                                            {
                                                                                title: 'Site',
                                                                                dataIndex: 'name',
                                                                            }
                                                                        ]}
                                                                        rowSelection={
                                                                            {
                                                                                type: 'radio',
                                                                                columnWidth: 20,
                                                                                selectedRowKeys: selectSite,
                                                                                onChange: onSiteChange,
                                                                            }
                                                                        }
                                                                    />
                                                                    <Table
                                                                        style={{width: "-webkit-fill-available"}}
                                                                        bordered={true}
                                                                        size={"small"}
                                                                        pagination={{
                                                                            pageSize: 5,
                                                                            defaultPageSize: 5,
                                                                        }}
                                                                        rowKey="id"
                                                                        dataSource={selectSite.length > 0 ? studyRoleList : []}
                                                                        columns={[
                                                                            {
                                                                                title: 'Role',
                                                                                dataIndex: 'name',
                                                                            }
                                                                        ]}
                                                                        rowSelection={
                                                                            {
                                                                                type: 'checkbox',
                                                                                columnWidth: 20,
                                                                                selectedRowKeys: selectRoles,
                                                                                onChange: onSelectRoles,
                                                                            }
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{textAlign: "center"}}>
                                                                    <Button style={{margin: "10px"}} type="primary" shape="round" size="large"
                                                                            disabled={selectRoles.length <= 0}
                                                                            onClick={add}>Add</Button>
                                                                </div>
                                                                <Form.Item name={'receiveRoleVOList'} rules={[
                                                                    {
                                                                        validator: async(_, roleList) => {

                                                                            //RoleList 정보 불러오기
                                                                            const userList = form.getFieldValue('emailNoticeReceiveUserList');
                                                                            //UserList 정보와 RoleList 정보 취합
                                                                            const listInfo = [...roleList, ...userList];

                                                                            if(listInfo.length > 0) {
                                                                                return Promise.resolve;
                                                                            } else {
                                                                                return Promise.reject(new Error(t("message.validator.no.receive.info")));
                                                                            }
                                                                        }
                                                                    }
                                                                ]}>
                                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                        <Table
                                                                            style={{width: "-webkit-fill-available"}}
                                                                            bordered={true}
                                                                            size={"small"}
                                                                            pagination={{
                                                                                pageSize: 5,
                                                                                defaultPageSize: 5,
                                                                            }}
                                                                            rowKey="name"
                                                                            dataSource={receiveRoleVOList}
                                                                            columns={[
                                                                                {
                                                                                    title: 'Env',
                                                                                    dataIndex: 'env',
                                                                                    key: 'env',
                                                                                    width: '15%',
                                                                                    align: 'center',
                                                                                },
                                                                                {
                                                                                    title: 'Site',
                                                                                    dataIndex: 'studySiteName',
                                                                                    key: 'studySiteId',
                                                                                    width: '30%',
                                                                                    align: 'center',
                                                                                },
                                                                                {
                                                                                    title: 'Role',
                                                                                    dataIndex: 'studyRoleName',
                                                                                    key: 'studyRoleId',
                                                                                    width: '30%',
                                                                                    align: 'center',
                                                                                },
                                                                                {
                                                                                    title: 'action',
                                                                                    dataIndex: 'action',
                                                                                    width: '10%',
                                                                                    align: 'center',
                                                                                    render: (_, receiveRole) =>
                                                                                        receiveRoleVOList.length >= 1 ? (
                                                                                            <MinusCircleOutlined style={{color: "red"}}
                                                                                                                 onClick={() => handleDelete(receiveRole)}/>
                                                                                        ) : null,
                                                                                },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </Form.Item>
                                                            </Tabs.TabPane>
                                                            <Tabs.TabPane tab={'User'} key={'user'}>
                                                                <Form.List name="emailNoticeReceiveUserList" rules={[
                                                                    {
                                                                        validator: async(_, userList) => {
                                                                            //RoleList 정보 불러오기
                                                                            const roleList = form.getFieldValue('receiveRoleVOList');
                                                                            //UserList 정보와 RoleList 정보 취합
                                                                            const listInfo = [...roleList, ...userList];

                                                                            if(listInfo.length > 0) {
                                                                                return Promise.resolve;
                                                                            } else {
                                                                                return Promise.reject(new Error(t("message.validator.no.receive.info")));
                                                                            }
                                                                        }
                                                                    }
                                                                ]}>
                                                                    {(fields, {add, remove}, {errors}) => (
                                                                        <>
                                                                            {fields.map(({
                                                                                             key,
                                                                                             name,
                                                                                             ...restField
                                                                                         }) => (
                                                                                <Space key={key} style={{
                                                                                    display: 'flex',
                                                                                    marginBottom: 8
                                                                                }} align="baseline">
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, 'receiveType']}
                                                                                        hidden={true}
                                                                                    >
                                                                                        <Select defaultValue="TO"
                                                                                                placeholder={"Type"}
                                                                                                options={[
                                                                                                    {value: 'TO', label: 'TO'},
                                                                                                    {value: 'CC', label: 'CC'},
                                                                                                    {value: 'BCC', label: 'BCC'}
                                                                                                ]}>
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, 'userName']}
                                                                                        rules={[{
                                                                                            required: true,
                                                                                            message: 'Missing userName'
                                                                                        }]}
                                                                                    >
                                                                                        <Input placeholder="User Name"/>
                                                                                    </Form.Item>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, 'email']}
                                                                                        rules={[{
                                                                                            required: true,
                                                                                            message: 'Missing email'
                                                                                        }]}
                                                                                    >
                                                                                        <Input placeholder="Email" style={{width:'300px'}}/>
                                                                                    </Form.Item>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, 'selectedEnvs']}
                                                                                        rules={[{
                                                                                            required: true,
                                                                                            message: 'Missing env'
                                                                                        }]}
                                                                                    >
                                                                                        <Select mode={"multiple"}
                                                                                                placeholder={"Environment"}
                                                                                                style={{minWidth: 220}}
                                                                                                options={[
                                                                                                    {value: 'DEV', label: 'DEV'},
                                                                                                    {value: 'UAT', label: 'UAT'},
                                                                                                    {value: 'PROD', label: 'PROD'}
                                                                                                ]}
                                                                                        >
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                    <MinusCircleOutlined style={{color: "red"}}
                                                                                                         onClick={() => remove(name)}/>
                                                                                </Space>

                                                                            ))}
                                                                            <Form.Item>
                                                                                <Button type="dashed" onClick={() => add()}
                                                                                        block icon={<PlusOutlined/>}>
                                                                                    Add
                                                                                </Button>
                                                                            </Form.Item>
                                                                            <Form.ErrorList className={'text-danger'} errors={errors}/>
                                                                        </>
                                                                    )}
                                                                </Form.List>
                                                            </Tabs.TabPane>
                                                        </Tabs>
                                                    </Card>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col span={24} style={{
                                                    textAlign: 'right', marginTop: 30
                                                }}>
                                                    <Form.Item>
                                                        <Button loading={isLoading} type="primary" htmlType="submit">
                                                            Submit
                                                        </Button>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Form>
                                </Space>
                            </Col>
                            <Col span={11} offset={1}>
                                <Card title={<h5>Preview</h5>}>
                                    <IntroduceContent dangerouslySetInnerHTML={{__html: renderPreviewHtml(editorToHtml)}}/>
                                </Card>
                            </Col>
                            {/*<Col flex="auto"></Col>*/}
                        </Row>
                    </DefaultCard>
                )
            }
        </>
    );

}

export default EmailNotice
